import { NotificationState } from "@app/core";

export class NotificationsStateChangedMessage{
    public notificationState: NotificationState;

    constructor(notificationState: NotificationState) {
        this.notificationState = notificationState;
    }
}